import { render, staticRenderFns } from "./ServiceableTypeList.vue?vue&type=template&id=6b12c1d2&scoped=true"
import script from "./ServiceableTypeList.vue?vue&type=script&lang=js"
export * from "./ServiceableTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b12c1d2",
  null
  
)

export default component.exports